import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

const AddressForm = ({ address, title='Address', onChange }) => {
    const [addressState, setAddressState] = useState(address);

    const handleAddressChange = (value, index) => {
        const updated = { ...addressState };
        updated.lines[index] = value;
        setAddressState(updated);
        onChange(updated);
    }

    const handlePostCodeChange = value => {
        const updated = { ...addressState, postcode: value };
        setAddressState(updated);
        onChange(updated);
    }

    if (!addressState) return <></>;

    return (
        <div >
            <Grid container direction="column" spacing={1}>
                <Grid item>
                    <Typography variant="h6" color="initial">{title}</Typography>
                </Grid>
                <Grid item>
                    <TextField value={addressState.lines[0] ?? ''} onChange={({ target: { value } }) => handleAddressChange(value, 0)} fullWidth />
                </Grid>
                <Grid item>
                    <TextField value={addressState.lines[1] ?? ''} onChange={({ target: { value } }) => handleAddressChange(value, 1)} fullWidth />
                </Grid>
                <Grid item>
                    <TextField value={addressState.lines[2] ?? ''} onChange={({ target: { value } }) => handleAddressChange(value, 2)} fullWidth />
                </Grid>
                <Grid item>
                    <TextField value={addressState.lines[3] ?? ''} onChange={({ target: { value } }) => handleAddressChange(value, 3)} fullWidth />
                </Grid>
                <Grid item>
                    <TextField value={addressState.postcode ?? ''} onChange={({ target: { value } }) => handlePostCodeChange(value)} placeholder="Postcode" label="Postcode" variant="outlined" fullWidth style={{ marginTop: '1rem'}} />
                </Grid>
            </Grid>
        </div>
    );
};

export default AddressForm;